import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0396a66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "q-pa-sm ecran-container",
  style: {"font-family":"'Roboto', sans-serif"}
}
const _hoisted_2 = { style: {"display":"flex","margin-right":"auto","align-items":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "app__color--label q-ma-md"
}
const _hoisted_4 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Articole Favorite")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_7 = { style: {"color":"#e8833a"} }
const _hoisted_8 = {
  key: 0,
  class: "app__label--medium app__color--semigray",
  style: {"padding-top":"5rem"}
}
const _hoisted_9 = { class: "q-pa-md container__all__products" }
const _hoisted_10 = {
  class: "produs_img",
  style: {"grid-area":"image"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute-full flex flex-center bg-negative text-white" }, " Cannot load image ", -1))
const _hoisted_12 = {
  class: "produs_detalii",
  style: {"grid-area":"description"}
}
const _hoisted_13 = { class: "app__property--medium" }
const _hoisted_14 = {
  class: "app__color--semigray",
  style: {"font-weight":"bold"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { key: 5 }
const _hoisted_21 = { key: 6 }
const _hoisted_22 = {
  key: 0,
  class: "app__color--semigray",
  style: {"font-weight":"lighter"}
}
const _hoisted_23 = {
  key: 1,
  class: "app__color--semigray",
  style: {"font-weight":"lighter","padding-left":"1rem"}
}
const _hoisted_24 = {
  key: 0,
  class: "app__color--semigray",
  style: {"font-weight":"lighter"}
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 1,
  class: "app__color--semigray",
  style: {"font-weight":"lighter","font-style":"italic"}
}
const _hoisted_28 = {
  class: "shopping_cart__container--btns",
  style: {"grid-area":"btns"}
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Elimina articolul din favorite ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Adauga in coș! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$q.platform.is.desktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_q_icon, {
                  name: "favorite_border",
                  style: {"font-size":"2rem","top":"-3px"},
                  color: "red"
                }),
                _hoisted_5
              ]),
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.favorites.length) + " articole", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.favorites.length ==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Nu aveti nimic in favorite! Selectați articolele dorite și adaugați-le in favorite! "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favorites, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.appid,
            class: "produs_div"
          }, [
            (item.appid==_ctx.appidToBeRemovedFromFavorites)
              ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                  key: 0,
                  indeterminate: "",
                  color: "secondary",
                  style: {"position":"absolute"}
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_q_img, {
                transition: "fade",
                src: _ctx.urlToJPG+'/'+item.categoryPid,
                ratio: "1",
                fit: "scale-down",
                "spinner-color": "light-blue",
                class: "rounded-borders shopping_cart--img shadow-1"
              }, {
                error: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["src"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(item.productName), 1),
              _createElementVNode("span", _hoisted_14, [
                (item.l)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Lungime " + _toDisplayString(item.l) + " mm ", 1))
                  : _createCommentVNode("", true),
                (item.w)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Latime " + _toDisplayString(item.w) + " mm ", 1))
                  : _createCommentVNode("", true),
                (item.t)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Grosime " + _toDisplayString(item.t) + " mm ", 1))
                  : _createCommentVNode("", true),
                (item.d)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Diametru " + _toDisplayString(item.d) + " mm ", 1))
                  : _createCommentVNode("", true),
                (item.h)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Inaltime " + _toDisplayString(item.h) + " mm ", 1))
                  : _createCommentVNode("", true),
                (item.a)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Aliaj " + _toDisplayString(item.a), 1))
                  : _createCommentVNode("", true),
                (item.k)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.k), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (item.um1 && item.qUm1>0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Cantitatea mea: " + _toDisplayString(item.qUm1) + " " + _toDisplayString(item.um1), 1))
                  : _createCommentVNode("", true),
                (item.um2 && item.qUm2>0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(item.qUm2) + " " + _toDisplayString(item.um2), 1))
                  : _createCommentVNode("", true)
              ]),
              (item.dorescDebitare)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                    _createTextVNode(_toDisplayString(item.qBuc) + " bucati cu debitare la ", 1),
                    (item.cuttingLength)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Lungimea " + _toDisplayString(item.cuttingLength) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.cuttingWidth)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, " Latimea " + _toDisplayString(item.cuttingWidth) + " mm ", 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (item.observatii)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Obs: " + _toDisplayString(item.observatii), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_q_btn, {
                color: "red",
                flat: "",
                onClick: ($event: any) => (_ctx.removeArticleFromFavorites(item)),
                "no-caps": "",
                "no-wrap": "",
                dense: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    left: "",
                    name: "delete_forever"
                  }),
                  _createVNode(_component_q_tooltip, {
                    anchor: "top middle",
                    self: "bottom middle",
                    offset: [10, 10],
                    "transition-show": "scale",
                    "transition-hide": "scale"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_q_btn, {
                color: "blue",
                flat: "",
                onClick: ($event: any) => (_ctx.addProductToBasket(item)),
                "no-caps": "",
                "no-wrap": "",
                dense: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "shopping_cart",
                    color: "blue"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, {
                        anchor: "top middle",
                        self: "bottom middle",
                        offset: [10, 10],
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}